// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-WoC","question":"styles_question__2kfBf","inputVisibleButton":"styles_inputVisibleButton__2nqUd","note":"styles_note__2xtxR"};